import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
import { ButtonContextProvider } from '@fluentui/react-button';
/**
 * Render the final JSX of MessageBarActions
 */
export const renderMessageBarActions_unstable = (state, contexts) => {
  assertSlots(state);
  if (state.layout === 'multiline') {
    return /*#__PURE__*/_jsxs(ButtonContextProvider, {
      value: contexts.button,
      children: [state.containerAction && /*#__PURE__*/_jsx(state.containerAction, {}), /*#__PURE__*/_jsx(state.root, {})]
    });
  }
  return /*#__PURE__*/_jsxs(ButtonContextProvider, {
    value: contexts.button,
    children: [/*#__PURE__*/_jsx(state.root, {}), state.containerAction && /*#__PURE__*/_jsx(state.containerAction, {})]
  });
};